import React, { Fragment } from 'react'

import Banner from './Banner'
import Content from './Content'

export default function AboutUsPage() {
    return (
        <Fragment>
            <Banner />
            <Content />
        </Fragment>
    )
}
